import { z } from "zod";

/** RFC 3339 timestamp with an explicit timezone (`Z` or an offset such as `+00:00`). */
export const isoDateTimeSchema = z.string().datetime({ offset: true });
